import { format, isEqual } from 'date-fns'
import { transformDate, uniqueValuesInArrOfObjs } from '../../utils/helpers'
import types from '../types'

const initialState = {
  isFetching: false,
  error: false,
  isSuccess: false,
  pga: -1,
  flareItems: [],
  flare: [],
  flareIsNull: true,
  s2kItems: [],
  s2k: [],
  s2kScores: [],
  pgas: [],
  lldas: [],
  damage: [],
  damageIsNull: true,
  damages: [],
  saveAssessment: {
    loading: false,
    error: false,
    success: false
  },
  pendS2k: false,
  getItems: {
    loading: false,
    success: false,
    error: false
  }
}

const assessmentReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.SET_ASSESSMENT_FETCHING:
    return {
      ...state,
      isFetching: true
    }
  case types.SET_ASSESSMENT_ERROR:
    return {
      ...state,
      error: action.payload,
      isFetching: false
    }
  case types.SET_ASSESSMENT_PATIENT:
    return {
      ...state,
      patient: action.payload
    }
  case types.GET_ASSESSMENT_ITEMS_REQUESTED: {
    return {
      ...state,
      getItems: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.GET_ASSESSMENT_ITEMS_FULFILLED: {
    // S2K
    const newS2kItems = action.payload.filter((s2kItem) => s2kItem.itemType.assessment === 'S2K')
    const newS2k = newS2kItems.map((item) => {
      return { 
        id: item.itemId, 
        points: item.points, 
        checked: false, 
        score: 0, 
        ruleId: item.ruleId,
        tag: item.rule.pocpId,
        showHistoricalData: item.showHistoricalData, 
        trendedLabs: item.trendedLabs || [] 
      }
    })

    // FLARE
    const newFlareItems = action.payload.filter((flareItem) => flareItem.itemType.assessment === 'Flare').sort((a, b) => a.itemId - b.itemId)
    const uniqueFlareItems = uniqueValuesInArrOfObjs(newFlareItems, 'name')
    const newFlare = uniqueFlareItems.map((flareItem) => {
      const mildFlare = newFlareItems.find((flare) => flare.name === flareItem && flare.itemTypeId === 2)
      const severeFlare = newFlareItems.find((flare) => flare.name === flareItem && flare.itemTypeId === 3)
      return {
        id: mildFlare.itemId,
        name: flareItem,
        value: '',
        description: '',
        mild: mildFlare,
        severe: severeFlare
      }
    })

    // LLDAS
    const newLLDASItems = action.payload.filter((item) => item.itemType.assessment === 'LLDAS')
    const newLLDAS = newLLDASItems.map((item) => ({
      id: item.itemId,
      checked: false,
      name: item.name
    })).sort((a, b) => a.id - b.id)

    // DAMAGE
    const damageItems = action.payload.filter((item) => item.itemType.assessment === 'Damage')
    const damageItemTypes = damageItems.map((damageItem) => damageItem.itemType).sort((a, b) => a.itemTypeId - b.itemTypeId)
    const uniqueDamageItemTypes = uniqueValuesInArrOfObjs(damageItemTypes, 'name')
    const newDamageItems = uniqueDamageItemTypes.map((itemType) => ({
      section: itemType,
      rows: damageItems.filter((di) => di.itemType.name === itemType).map((i) => ({ id: i.itemId, points: i.points, checked: false, score: 0, name: i.name })).sort((a, b) => a.id - b.id)
    }))

    return {
      ...state,
      s2kItems: newS2kItems,
      flareItems: newFlareItems,
      s2k: newS2k,
      flare: newFlare,
      lldas: newLLDAS,
      damage: newDamageItems,
      getItems: {
        ...state.getItems,
        loading: false,
        success: true
      }
    }
  }
  case types.GET_ASSESSMENT_ITEMS_REJECTED: {
    return {
      ...state,
      getItems: {
        loading: false,
        error: action.payload,
        success: false
      }
    }
  }
  case types.SET_ASSESSMENT_ENCOUNTER: {
    const { rulesData, patientHistory } = action.payload
    const newS2k = rulesData.map((item) => {
      const s2kItem = state.s2k.find((s2k) => s2k.ruleId === parseInt(item.id.split('_')[1]))
      const results = item.ruleResult.reduce((acc, curr) => {
        if (curr.result && curr.result.length > 0) {
          return [...acc, ...curr.result]
        }

        return acc
      }, []).filter((result, index, self) => {
        if (result.effectiveDate) {
          return self.findIndex((r) => r.code === result.code && isEqual(new Date(r.effectiveDate), new Date(result.effectiveDate))) === index
        }

        return result
      })

      return {
        ...s2kItem,
        checked: item.value,
        score: item.value ? s2kItem.points : 0,
        results,
        dates: results.map((result) => result ? format(new Date(result.effectiveDate ? transformDate(result.effectiveDate) : transformDate(result.onsetStartDate)), 'MM/dd/yyyy') : '')
      }
    })
    return {
      ...state,
      isSuccess: true,
      isFetching: false,
      s2k: newS2k,
      s2kScores: patientHistory.sledais,
      damages: patientHistory.damages,
      pgas: patientHistory.pgas
    }
  }
  case types.GET_ASSESSMENT_FULFILLED: {
    const { encounter: { pga, sledai, flare, damage, lldas }, patientHistory, s2kRules } = action.payload

    // S2K
    const newSledai = state.s2k.map((s2k) => {
      const s2kItem = sledai.items.find((item) => item.itemId === s2k.id)
      const s2kRule = s2kRules.find((rule) => rule.id === s2k.tag)
      const results = s2kRule ? s2kRule.ruleResult.reduce((acc, curr) => {
        if (curr.result && curr.result.length > 0) {
          return [...acc, ...curr.result]
        }

        return acc
      }, []).filter((result, index, self) => {
        if (result.effectiveDate) {
          return self.findIndex((r) => r.code === result.code && isEqual(new Date(r.effectiveDate), new Date(result.effectiveDate))) === index
        }

        return result
      }) : []

      return {
        ...s2k,
        checked: s2kItem ? true : false,
        score: s2kItem ? s2kItem.item.points : 0,
        results,
        dates: results.map((result) => result ? format(new Date(result.effectiveDate ? transformDate(result.effectiveDate) : transformDate(result.onsetStartDate)), 'MM/dd/yyyy') : '')
      }
    })

    const newS2kScores = patientHistory.sledais

    // Flare
    const newFlare = state.flare.map((f) => {
      const mildFlare = flare ? flare.items.find((flareItem) => flareItem.description === f.mild.guideline) : null
      const severeFlare = flare ? flare.items.find((flareItem) => flareItem.description === f.severe.guideline) : null

      if (mildFlare) {
        return {
          ...f,
          value: 'Mild/Moderate',
          description: mildFlare.description
        }
      }

      if (severeFlare) {
        return {
          ...f,
          value: 'Severe',
          description: severeFlare.description
        }
      }

      return f
    })

    // Damage Index
    const newDamage = state.damage.map((d) => {
      const newRows = d.rows.map((row) => {
        const foundRow = damage ? damage.items.find((damageItem) => damageItem.itemId === row.id) : null
        return {
          ...row,
          checked: !!foundRow,
          score: foundRow ? foundRow.result : 0
        }
      })
      return {
        section: d.section,
        rows: newRows
      }
    })

    // LLDAS
    const newLldas = state.lldas.map((l) => {
      const foundItem = lldas.find((item) => item.itemId === l.id)
      return {
        ...l,
        checked: !!foundItem
      }
    })

    return {
      ...state,
      isSuccess: true,
      isFetching: false,
      pga: pga ? pga.value : -1,
      pgas: patientHistory.pgas,
      s2k: newSledai,
      s2kScores: newS2kScores,
      flare: newFlare,
      damage: newDamage,
      lldas: newLldas,
      damages: patientHistory.damages
    }
  }
  case types.SET_ASSESSMENT_PGA: {
    return {
      ...state,
      pga: action.payload
    }
  }
  case types.UPDATE_ASSESSMENT_S2K: {
    const { event } = action.payload
    const s2kIndex = state.s2k.findIndex((s) => s.id === parseInt(event.target.name))
    const s2kItem = state.s2k.find((item) => item.id === parseInt(event.target.name))

    const newItem = {
      ...s2kItem,
      checked: event.target.checked,
      score: event.target.checked ? s2kItem.points : 0
    }
    return {
      ...state,
      s2k: [
        ...state.s2k.slice(0, s2kIndex),
        newItem,
        ...state.s2k.slice(s2kIndex + 1)
      ]
    }
  }
  case types.UPDATE_ASSESSMENT_FLARE: {
    const { key, flare, description } = action.payload
    const index = state.flare.findIndex((f) => f.id === key)
    return {
      ...state,
      flareIsNull: false,
      flare: [
        ...state.flare.slice(0, index),
        {
          ...state.flare[index],
          value: flare,
          description
        },
        ...state.flare.slice(index + 1)
      ]
    }
  }
  case types.SET_ASSESSMENT_NO_FLARE: {
    return {
      ...state,
      flareIsNull: false,
      flare: state.flare.map((f) => ({
        ...f,
        value: '',
        description: ''
      }))
    }
  }
  case types.RESET_ASSESSMENT_FLARE: {
    return {
      ...state,
      flareIsNull: true,
      flare: state.flare.map((f) => ({
        ...f,
        value: '',
        description: ''
      }))
    }
  }
  case types.UPDATE_ASSESSMENT_LLDAS: {
    const { id, checked } = action.payload
    const index = state.lldas.findIndex((lldas) => lldas.id === parseInt(id, 10))
    return {
      ...state,
      lldas: [
        ...state.lldas.slice(0, index),
        {
          ...state.lldas[index],
          checked
        },
        ...state.lldas.slice(index + 1)
      ]
    }
  }
  case types.RESET_ASSESSMENT_LLDAS: {
    return {
      ...state,
      lldas: state.lldas.map((lldas) => ({
        ...lldas,
        checked: false
      }))
    }
  }
  case types.UPDATE_ASSESSMENT_DAMAGE: {
    const { section, event: { id, checked } } = action.payload
    const sectionIndex = state.damage.findIndex((d) => d.section === section)
    const rowIndex = state.damage[sectionIndex].rows.findIndex((r) => r.id === parseInt(id, 10))
    return {
      ...state,
      damage: [
        ...state.damage.slice(0, sectionIndex),
        {
          ...state.damage[sectionIndex],
          rows: [
            ...state.damage[sectionIndex].rows.slice(0, rowIndex),
            {
              ...state.damage[sectionIndex].rows[rowIndex],
              checked,
              score: checked ? state.damage[sectionIndex].rows[rowIndex].points : 0
            },
            ...state.damage[sectionIndex].rows.slice(rowIndex + 1)
          ]
        },
        ...state.damage.slice(sectionIndex + 1)
      ],
      damageIsNull: false
    }
  }
  case types.SET_ASSESSMENT_NO_DAMAGE_INDEX: {
    return {
      ...state,
      damage: state.damage.map((d) => {
        const newRows = d.rows.map((row) => ({
          ...row,
          checked: false,
          score: 0
        }))

        return {
          ...d,
          rows: newRows
        }
      }),
      damageIsNull: false
    }
  }
  case types.RESET_ASSESSMENT_DAMAGE: {
    return {
      ...state,
      damage: state.damage.map((d) => {
        const newRows = d.rows.map((row) => ({
          ...row,
          checked: false,
          score: 0
        }))

        return {
          ...d,
          rows: newRows
        }
      }),
      damageIsNull: true
    }
  }
  case types.SAVE_ASSESSMENT_REQUESTED: {
    return {
      ...state,
      saveAssessment: {
        loading: true,
        error: false,
        success: false
      }
    }
  }
  case types.SAVE_ASSESSMENT_FULFILLED: {
    return {
      ...state,
      saveAssessment: {
        ...state.saveAssessment,
        loading: false,
        success: true
      }
    }
  }
  case types.SAVE_ASSESSMENT_REJECTED: {
    return {
      ...state,
      saveAssessment: {
        ...state.saveAssessment,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.CLEAR_ASSESSMENT: {
    const newS2k = state.s2k
    newS2k.forEach((item) => {
      if (item.checked) {
        item.checked = false
        item.score = 0
      }
    })

    const newFlare = []
    for (let i = 0; i < 5; i++) {
      newFlare.push(state.flare[state.flareItems[i].itemId])
      newFlare[i].value = ''
      newFlare[i].description = ''
    }

    return {
      ...state,
      pga: 0
    }
  }
  case types.EXIT_ASSESSMENT: {
    const exit = 'Fulfilled'
    return {
      ...state,
      exit
    }
  }
  case types.SET_PEND_S2K: {
    return {
      ...state,
      pendS2k: action.payload
    }
  }
  default:
    return state
  }
}

export default assessmentReducer
